export default {
  team: null,
  teams: null,
  schemaTicketForm: null,
  fieldSchemaTicketForm: null,
  schemaContactForm: null,
  schemaTicketExport: null,
  schemaTicketImport: null,
  schemaContactExport: null,
  schemaTicketFilters: null,
};
